module.exports = __webpack_public_path__ + "img/client-5.bef3f3a8.webp";